<template>
  <div :class="['cf-quantity-input', { 'cf-full-width': isFullWidth }]">
    <label
      v-if="label"
      class="cf-quantity-input__label"
      :for="name"
    >
      {{ label }}:
    </label>

    <div
      :class="[
        'cf-quantity-input__controls', {
          'cf-quantity-input__controls--small': size === 'small',
          'cf-full-width cf-flex--justify-space-between': isFullWidth,
          'cf-no-border': clearBorderStyle,
        },
      ]"
    >
      <button
        class="cf-quantity-input__button"
        type="button"
        :disabled="modelValue <= 1"
        aria-label="Decrease Quantity"
        @click="decrease"
      >
        <span class="cf-icon fa-minus" />
      </button>

      <input
        :id="name"
        class="cf-quantity-input__input"
        type="number"
        :name="name"
        :value="modelValue"
        readonly
        tabindex="-1"
      >

      <button
        class="cf-quantity-input__button"
        type="button"
        :disabled="maxValue > -1 && modelValue >= maxValue"
        aria-label="Increase Quantity"
        @click="increase"
      >
        <span class="cf-icon fa-plus" />
      </button>
    </div>
  </div>
</template>



<script>
  export default {
    name: 'QuantityInput',

    props: {
      label: {
        type: String,
        default: ''
      },

      size: {
        type: String,
        default: null
      },

      isFullWidth: {
        type: Boolean,
        default: false
      },

      maxValue: {
        type: Number,
        default: -1
      },

      name: {
        type: String,
        required: true
      },

      modelValue: {
        type: Number,
        required: true
      },

      clearBorderStyle: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      decrease() {
        const newValue = this.modelValue - 1;

        if (newValue > 0) {
          this.$emit('update:modelValue', newValue);
        }
      },

      increase() {
        const newValue = this.modelValue + 1;

        if (this.maxValue === -1 || this.maxValue >= newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    }
  };
</script>
